import {keyframes} from '@emotion/react'

const enterTextAnimation = keyframes`
    from {
        transform: translateX(150%);
    }
    to {
        transform: translateX(0);
    }
`

const getAlignment = (textAlign): string => {
    if (textAlign === 'left') return 'flex-start'
    if (textAlign === 'right') return 'flex-end'
    return 'center'
}

const getCtaJustify = (textAlign, ctaNum): string => {
    if (ctaNum === 1) {
        if (textAlign === 'left') return 'flex-start'
        if (textAlign === 'center') return 'center'
        if (textAlign === 'right') return 'flex-end'
    }

    return 'space-evenly'
}

const titleTextCta = {
    TitleTextCta: {
        baseStyle: ({textAlign, horizontalPosition, contentColor, contentBackground, textAnimation, fullHeight, ctaNum}) => ({
            wrapper: {
                w: '100%',
                gridColumn: '1 / -1', // Starts from the first column end ends at the last column
                backgroundColor: contentBackground,
                color: contentColor,
                ...(fullHeight && {
                    h: '100dvh',
                    display: 'flex',
                    alignItems: 'center',
                }),
            },
            container: {
                w: '65%',
                marginLeft: horizontalPosition === 'left' ? 'spacing.16' : 'auto',
                marginRight: horizontalPosition === 'right' ? 'spacing.16' : 'auto',
                alignItems: getAlignment(textAlign),
                textAlign: textAlign,
            },

            ctaContainer: {
                w: '100%',
                flexDirection: {base: 'column', md: 'row'},
                alignItems: 'center',
                justifyContent: getCtaJustify(textAlign, ctaNum),
            },
            eyelet: {
                textStyle: 'paragraphLg',
                fontFamily: 'GTEesti',
                fontWeight: '300',
                mb: 'spacing.2',
            },
            title: {
                textStyle: 'displaySm',
                fontFamily: 'GTEesti',
                fontWeight: '400',
                animation: textAnimation ? `${enterTextAnimation} 1000ms cubic-bezier(.25,.1,.25,1)` : 'none',
            },
            text: {
                pt: 'spacing.3',
                textStyle: 'paragraphMd',
            },
        }),
    },
}

export default titleTextCta
